module.exports = __webpack_public_path__ + "static/media/background.9b5f80b6.jpg";